import type { Document } from '@contentful/rich-text-types';
import type { ValueOf } from 'type-fest';

export const themes = {
  blueLinks: 'blue-links',
  greenCheckmarkList: 'green-checkmark-list',
  orangeLinks: 'orange-links',
  whiteCheckmarkList: 'white-checkmark-list',
  boldMarkerList: 'bold-marker-list',
  disclaimer: 'disclaimer',
} as const;

export type RichText = {
  className?: string;
  content?: Document;
  theme?: ValueOf<typeof themes>;
};
